import React from 'react';
import { Pressable, StyleSheet, Text } from 'react-native';
import { confirmDestructive } from '../ui/dialogs';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useChat } from '../contexts/ChatContext';
import { useAuth } from '../contexts/AuthContext';
import { colors, typography } from '../config/theme';
import AdminHomeScreen from '../screens/admin/AdminHomeScreen';
import ScheduleAdminScreen from '../screens/admin/ScheduleAdminScreen';
import ScheduleTemplateScreen from '../screens/admin/ScheduleTemplateScreen';
import ChecklistListScreen from '../screens/admin/ChecklistListScreen';
import ChecklistEditorScreen from '../screens/admin/ChecklistEditorScreen';
import EmployeeListScreen from '../screens/admin/EmployeeListScreen';
import LocationsScreen from '../screens/admin/LocationsScreen';
import ProductExpiriesScreen from '../screens/ProductExpiriesScreen';
import ShiftReportsScreen from '../screens/admin/ShiftReportsScreen';
import EmployeeHomeScreen from '../screens/employee/EmployeeHomeScreen';
import MyScheduleScreen from '../screens/employee/MyScheduleScreen';
import HelpScreen from '../screens/HelpScreen';
import AiScreen from '../screens/AiScreen';
import ChatNavigator from './ChatNavigator';

const Tab = createBottomTabNavigator();
const Stack = createNativeStackNavigator();

const screenHeader = {
  headerStyle: { backgroundColor: colors.background },
  headerTintColor: colors.textPrimary,
  headerShadowVisible: false,
  headerTitleStyle: { ...typography.h3 },
  contentStyle: { backgroundColor: colors.background },
};

function LogoutButton() {
  const { logout } = useAuth();
  const confirm = () => confirmDestructive('Выйти из аккаунта?', 'Нужно будет войти заново.', 'Выйти', logout);
  return (
    <Pressable onPress={confirm} hitSlop={10}>
      <Text style={styles.logout}>Выйти</Text>
    </Pressable>
  );
}

function AdminTabs() {
  const insets = useSafeAreaInsets();
  const { total } = useChat();
  const bottom = Math.max(insets.bottom, 6);
  return (
    <Tab.Navigator
      screenOptions={{
        ...screenHeader,
        tabBarActiveTintColor: colors.primary,
        tabBarInactiveTintColor: colors.textMuted,
        tabBarLabelStyle: { fontFamily: typography.button.fontFamily, fontSize: 10.5, fontWeight: '800', letterSpacing: 0 },
        tabBarIconStyle: { display: 'none' },
        tabBarStyle: { backgroundColor: colors.surface, borderTopColor: colors.border, borderTopWidth: 1, paddingTop: 10, paddingBottom: bottom, height: 54 + bottom },
      }}
    >
      <Tab.Screen name="AdminHome" component={AdminHomeScreen} options={{ title: 'Обзор', tabBarLabel: 'Обзор', headerRight: () => <LogoutButton /> }} />
      <Tab.Screen name="ScheduleAdmin" component={ScheduleAdminScreen} options={{ title: 'График смен', tabBarLabel: 'График' }} />
      <Tab.Screen name="Checklists" component={ChecklistListScreen} options={{ title: 'Чек-листы и задачи', tabBarLabel: 'Задачи' }} />
      <Tab.Screen name="Employees" component={EmployeeListScreen} options={{ title: 'Сотрудники', tabBarLabel: 'Люди' }} />
      <Tab.Screen name="Chat" component={ChatNavigator} options={{ headerShown: false, tabBarLabel: 'Чат', tabBarBadge: total || undefined }} />
      <Tab.Screen name="Help" component={HelpScreen} options={{ title: 'Памятка', tabBarLabel: 'Памятка' }} />
    </Tab.Navigator>
  );
}

const styles = StyleSheet.create({
  logout: { ...typography.button, fontSize: 14, color: colors.textSecondary, paddingHorizontal: 4 },
});

export default function AdminNavigator() {
  return (
    <Stack.Navigator screenOptions={screenHeader}>
      <Stack.Screen name="AdminTabs" component={AdminTabs} options={{ headerShown: false }} />
      <Stack.Screen name="ChecklistEditor" component={ChecklistEditorScreen} options={{ title: 'Чек-лист' }} />
      <Stack.Screen name="Locations" component={LocationsScreen} options={{ title: 'Точки и типы смен' }} />
      <Stack.Screen name="ProductExpiries" component={ProductExpiriesScreen} options={{ title: 'Сроки годности' }} />
      <Stack.Screen name="ShiftReports" component={ShiftReportsScreen} options={{ title: 'Отчёты по сменам' }} />
      <Stack.Screen name="MyShift" component={EmployeeHomeScreen} options={{ title: 'Моя смена' }} />
      <Stack.Screen name="MySchedule" component={MyScheduleScreen} options={{ title: 'Мой график' }} />
      <Stack.Screen name="ScheduleTemplate" component={ScheduleTemplateScreen} options={{ title: 'Шаблон недели' }} />
      <Stack.Screen name="Assistant" component={AiScreen} options={{ title: 'Помощник · Аналитика' }} />
    </Stack.Navigator>
  );
}
